module.exports = __webpack_public_path__ + "img/home-newcampaign-2024.e688d494.jpg";